export const meta = { id: 'O30', slug: 'publicar-formacao', title: 'Como publicar uma Formação', description: 'Revise o programa antes de mudar o status de Rascunho para Publicada.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 600, keywords: ['publicar formação','rascunho','publicada','arquivada'], previous: 'O29', next: 'O31', related: ['O21','O22','O23'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como publicar uma Formação

Mantenha a Formação em **Rascunho** enquanto a estrutura ainda estiver sendo montada e revisada.

<Steps>
  <Step title="Revise a identidade">Confirme objetivo, público, modalidade e resultados esperados.</Step>
  <Step title="Revise o currículo">Confira Etapas, Componentes, ordem e Treinamentos vinculados.</Step>
  <Step title="Revise as regras">Valide obrigatoriedade e pré-requisitos.</Step>
  <Step title="Publique">Altere o status quando a Formação estiver pronta para uso.</Step>
</Steps>

<Callout type="warning">Arquive quando a Formação não deva mais ser utilizada conforme a operação atual. Evite tratar Arquivada como simples rascunho temporário.</Callout>
